import { AnimatePresence, motion, useInView } from "motion/react";
import { useRef } from "react";

const defaultVariants = {
  fadeIn:   { hidden: { opacity: 0, y: 20 },                           show: { opacity: 1, y: 0 } },
  blurInUp: { hidden: { opacity: 0, filter: "blur(8px)", y: 16 },      show: { opacity: 1, filter: "blur(0px)", y: 0 } },
  blurIn:   { hidden: { opacity: 0, filter: "blur(8px)" },             show: { opacity: 1, filter: "blur(0px)" } },
  slideUp:  { hidden: { opacity: 0, y: 24 },                           show: { opacity: 1, y: 0 } },
};

export function TextAnimate({
  children, as: Tag = "span", className, segmentClassName,
  delay = 0, duration = 0.5, variants, by = "word",
  animation = "blurInUp", startOnView = true, once = true, style, ...props
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, margin: "0px 0px -40px 0px" });
  const shouldAnimate = startOnView ? inView : true;
  const selectedVariants = variants ?? defaultVariants[animation] ?? defaultVariants.blurInUp;

  if (by === "block" || typeof children !== "string") {
    return (
      <Tag ref={ref} className={className} style={style} {...props}>
        <motion.span
          className={segmentClassName}
          style={{ display: "block" }}
          variants={selectedVariants}
          initial="hidden"
          animate={shouldAnimate ? "show" : "hidden"}
          transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
        >
          {children}
        </motion.span>
      </Tag>
    );
  }

  const segments =
    by === "character" ? children.split("") :
    by === "line"      ? children.split("\n") :
    children.split(/(\s+)/);

  return (
    <Tag ref={ref} className={className} style={style} {...props}>
      <AnimatePresence>
        {segments.map((segment, i) => (
          <motion.span
            key={i}
            className={segmentClassName}
            style={{ display: segment.trim() === "" ? "inline" : "inline-block" }}
            variants={selectedVariants}
            initial="hidden"
            animate={shouldAnimate ? "show" : "hidden"}
            transition={{ duration, delay: delay + i * 0.06, ease: [0.22, 1, 0.36, 1] }}
          >
            {segment}
          </motion.span>
        ))}
      </AnimatePresence>
    </Tag>
  );
}
